module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "hidden-md-and-down",
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isManager('finance|property|admin')),
      expression: "isManager('finance|property|admin')"
    }],
    attrs: {
      "icon": "fa fa-trash-alt",
      "size": "small",
      "type": "danger",
      "circle": "",
      "disabled": _vm.isViewOnly()
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5097045c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/controls/InsuranceControls.vue
// module id = 1486
// module chunks = 0